import { thousand } from '../../../utils/format';

export const getChartOptions = () => ({
  responsive: true,
  title: false,
  legend: {
    labels: {
      usePointStyle: true, // Use a circular point style instead of a rectangle
      pointStyle: 'circle', // Set the shape to a circle
    },
  },
  layout: {
    padding: {
      top: 0,
      bottom: 0,
      left: -20,
      right: 0
    },
    margin: 0
  },
  scales: {
    xAxes: [
      {
        offset: true,
        gridLines: false,
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
        },
        offset: true,
        gridLines: { drawBorder: false },
        ticks: { beginAtZero: true },
      },
    ],
  },
  tooltips: {
    displayColors: false,
    titleMarginBottom: 5,
    backgroundColor: '#fff',
    position: 'average',
    titleFontColor: '#666',
    bodyFontColor: '#666',
    borderColor: '#ededed',
    borderWidth: 1,
    callbacks: {
      title: function (tooltipItems) {
        return thousand(tooltipItems[0].value);
      },
      label: function (tooltipItem) {
        return BAR_LABEL[Object.keys(BAR_LABEL)[tooltipItem.datasetIndex]];
      },
    },
    titleFontSize: 15,
    xPadding: 15,
    yPadding: 10,
    titleAlign: 'center',
    bodyAlign: 'center',
  },
});

export const BAR_COLOR = {
  REGISTRASI_BERHASIL: 'rgba(218, 35, 26, 1)',
  SUDAH_ONBOARDING: 'rgba(20, 111, 180, 1)',
  SUDAH_TRANSAKSI: 'rgba(133, 194, 37, 1)',
};

export const BAR_LABEL = {
  REGISTRASI_BERHASIL: 'Registrasi Berhasil',
  SUDAH_ONBOARDING: 'Onboarding',
  SUDAH_TRANSAKSI: 'Transaksi',
};
